import { Component } from '@angular/core';

@Component({
  selector: 'app-baseerror',
  standalone: true,
  imports: [],
  templateUrl: './baseerror.component.html',
  styleUrl: './baseerror.component.css',
})
// base-error.component.ts
export class BaseErrorComponent {
  statusCode = 0;
  showErrorPage = false;
  nodataFound = false;
  showErrorModal = false;
  showSuccessModal = false;

  constructor() {}

  protected setErrorPage(statusCode: number): void {
    this.statusCode = statusCode;
    this.showErrorPage = true;
  }

  protected resetErrorPage(): void {
    this.showErrorPage = false;
  }
}
